/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Component, Input, ElementRef, Renderer, ViewEncapsulation, HostBinding } from '@angular/core';
import { Inject, Host, forwardRef } from '@angular/core';

import classNames from 'classnames';

import { Table } from './table';
/**
 * 表格：内容
 */
export class TableContent {
/**
 * 用户CSS样式
 */
class: string;
/**
 * 样式前缀
 * @return {?}
 */
get prefixCls(): string {
        return this.table && this.table.prefixCls || '';
    }
/**
 * @param {?} _renderer
 * @param {?} _elementRef
 * @param {?} table
 */
constructor(
private _renderer: Renderer,
private _elementRef: ElementRef,
public table: Table) {

    }
/**
 * @return {?}
 */
get classes(): string {
        return classNames({
            [`${this.prefixCls}-content`]: 1
        }, this.class);
    }


static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'table-content',
    templateUrl: './table.content.html',
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
{type: Table, decorators: [{ type: Inject, args: [forwardRef(() => Table), ] }, { type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'class': [{ type: Input },],
'classes': [{ type: HostBinding, args: ['class', ] },],
};
}

function TableContent_tsickle_Closure_declarations() {
/** @type {?} */
TableContent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TableContent.ctorParameters;
/** @type {?} */
TableContent.propDecorators;
/**
 * 用户CSS样式
 * @type {?}
 */
TableContent.prototype.class;
/** @type {?} */
TableContent.prototype._renderer;
/** @type {?} */
TableContent.prototype._elementRef;
/** @type {?} */
TableContent.prototype.table;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
